import React from 'react'
import styled from 'styled-components'
import Brightness from '../scripts/Brightness'

import PreviewButton from './PreviewButton'
import SiteIcons from '../assets/SiteIcons'

import LogThis from '../scripts/LogThis'

const CourseListView = (props) => {

  let bgImageStyle

  if (props.courseImg !== undefined) {
    bgImageStyle = {
      backgroundImage: 'url(https://assets.lmscourses.com/lesson-screenshots/' + props.courseImg + ')'
    }
  }

  const AddToReport = props.courseLanguages.split('|')
  const Languages = ['English']

  if (AddToReport.includes('Spanish')) {
    Languages.push('Spanish')
  }

  if (AddToReport.includes('French')) {
    Languages.push('French')
  }


  const ListBackgroundStyles = styled.div`
    color: ${props.themeStyles.fontColor};
  `
  return (

    <div className="courseContainer">
      <ListBackgroundStyles className="course">
          <div className="courseScreenshotContainer">
            <div className="courseThumbArea" style={bgImageStyle}></div>
          </div>
          <div className="courseDetails">
            <h1>{props.courseName}</h1>
            <div className="courseSpecDetails">
              <span className="duration">
                <SiteIcons icon="time" />
                <span>{props.courseHours}:{props.courseMins}</span>
              </span>
              <span className="languages">
                <SiteIcons icon="languages" />
                {Languages.map((lan, idx) => {

                  let langComma = ''
                  let langLength = Languages.length - 1;

                  if ( idx !== langLength) {
                    langComma = ','
                  }

                  return <span key={idx}>{lan}{langComma}</span>
                })}
              </span>
            </div>
              <p>{props.desc}</p>
              <PreviewButton
                localURL={props.localURL}
                courseURL={props.courseURL}
                courseName={props.courseName}
                loggedInInfo={props.loggedInInfo}
                languages={Languages}
                supported={props.supported}
                themeStyles={props.themeStyles}
               />
          </div>
      </ListBackgroundStyles>
    </div>

  )

}



export default CourseListView
